var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5263 11.584L9.32712 6.12095L11.6589 3.78916C12.6582 2.78982 12.9914 1.45737 12.6582 0.791146C11.992 0.458034 10.6596 0.791146 9.66024 1.79048L7.32845 4.12227L1.8654 2.92307C1.53229 2.85644 1.2658 2.98969 1.13256 3.25618L0.932689 3.58929C0.799444 3.9224 0.866066 4.25552 1.13256 4.45538L4.66355 6.78717L3.3311 8.78585H1.33242L0.666199 9.45207L2.66487 10.7845L3.99732 12.7832L4.66355 12.117V10.1183L6.66222 8.78585L8.99401 12.3168C9.19388 12.5833 9.52699 12.65 9.8601 12.5167L10.1932 12.3835C10.4597 12.1836 10.593 11.9171 10.5263 11.584Z",
    stroke: "black",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlight);
export default __webpack_public_path__ + "static/media/flight.22830bbdfb557d289fd30e0d8efefb7c.svg";
export { ForwardRef as ReactComponent };